/* Bare, currentColor agent-kind glyphs for the onboarding / agent-creation
 * type tiles (Figma 199:8794) and other inline uses — the same marks as the
 * colored tiles in ./index.tsx, minus the tile ground, so they tint with the
 * surrounding text (selected vs. muted tile states). */

export function ClaudeGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 33 33" fill="none" className={className} aria-hidden>
      <g stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
        <path d="M7.275 16.125h18.725" />
        <path d="M22.923 22.923 9.689 9.688" />
        <path d="M16.125 26V7.275" />
        <path d="M9.689 22.923 22.923 9.688" />
      </g>
    </svg>
  );
}

export function LangChainGlyph({ className }: { className?: string }) {
  // The link path spans ~7.7–25.3 of the 33-unit tile; the tight viewBox
  // keeps its optical size in step with the other glyphs.
  return (
    <svg viewBox="6 6 21 21" fill="none" className={className} aria-hidden>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M17.9084 9.28323C19.5123 7.67935 22.1127 7.67935 23.7166 9.28323C25.3204 10.8871 25.3204 13.4875 23.7166 15.0914L19.8857 18.9222C19.1199 19.7024 18.0725 20.1419 16.9792 20.1419C15.8845 20.1419 14.836 19.7013 14.0699 18.9195C13.7921 18.6359 13.7968 18.1809 14.0803 17.9031C14.3638 17.6253 14.8189 17.6299 15.0967 17.9134C15.5924 18.4194 16.2709 18.7044 16.9792 18.7044C17.6874 18.7044 18.3659 18.4194 18.8616 17.9134L18.8667 17.9082L18.8668 17.9082L22.7001 14.0749C23.7426 13.0324 23.7426 11.3422 22.7001 10.2997C21.6576 9.2572 19.9674 9.2572 18.9249 10.2997L18.4457 10.7789C18.165 11.0595 17.71 11.0595 17.4293 10.7789C17.1486 10.4982 17.1486 10.0431 17.4293 9.76239L17.9084 9.28323ZM13.1143 14.0774C13.8801 13.2973 14.9275 12.8577 16.0208 12.8577C17.1155 12.8577 18.164 13.2983 18.9301 14.0802C19.2079 14.3637 19.2032 14.8188 18.9197 15.0966C18.6362 15.3744 18.1811 15.3698 17.9033 15.0862C17.4076 14.5803 16.7291 14.2952 16.0208 14.2952C15.3126 14.2952 14.6341 14.5803 14.1384 15.0862L14.1333 15.0915L14.1332 15.0914L10.2999 18.9248C9.25741 19.9673 9.25741 21.6575 10.2999 22.7C11.3424 23.7425 13.0326 23.7425 14.0751 22.7L14.5543 22.2208C14.835 21.9401 15.29 21.9401 15.5707 22.2208C15.8514 22.5015 15.8514 22.9566 15.5707 23.2373L15.0916 23.7164C13.4877 25.3203 10.8873 25.3203 9.28344 23.7164C7.67957 22.1126 7.67957 19.5122 9.28344 17.9083L13.1143 14.0774Z"
      />
    </svg>
  );
}

export function CodexGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 33 33" fill="none" className={className} aria-hidden>
      <g
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10.2812 22.433 16.2531 16.4611 10.2812 10.4893" />
        <path d="M18.2437 24.4236h7.9625" />
      </g>
    </svg>
  );
}

export function GlobeGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 15 15" fill="none" className={className} aria-hidden>
      <g
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.5 13.75C10.9518 13.75 13.75 10.9518 13.75 7.5C13.75 4.04822 10.9518 1.25 7.5 1.25C4.04822 1.25 1.25 4.04822 1.25 7.5C1.25 10.9518 4.04822 13.75 7.5 13.75Z" />
        <path d="M5 7.5C5 5.17296 5.89515 2.9351 7.5 1.25C9.10485 2.9351 10 5.17296 10 7.5C10 9.82704 9.10485 12.0649 7.5 13.75C5.89515 12.0649 5 9.82704 5 7.5Z" />
        <path d="M1.25 7.5H13.75" />
      </g>
    </svg>
  );
}
